import React, {useState, useEffect, useRef} from 'react';
import { Button, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../styles/tailwind';
import Text from '../../../../components/Text';
import Icon from '../../../../components/IcomoonIcon';
import Modal from '../../../../components/Modal';
import BottomSheet from '../../../../components/BottomSheet';
import Input from '../../../../components/Forms/Input';
import { useForm } from 'react-hook-form';
import IconButton from '../../../../components/IconButton';
import useFormSubmit from '../../../../hooks/useFormSubmit';


function ColorButton({selected=false, style="", color, onPress}){
  return (
    <TouchableOpacity
      style={tw.style(`rounded-full h-7 w-7 bg-[${color}]`, style, selected && `border-[3px] border-primary`)} 
      onPress={onPress}
    />
  )
}


export const vehicleColors = [
  { name: "Blanco", hex: "#fff", style: `border border-gray-200` },
  { name: "Gris", hex: "#b3b3b3" },
  { name: "Negro", hex: "#000" },
  { name: "Rojo", hex: "#ed1c24" },
  { name: "Azul", hex: "#29abe2" },
  { name: "Amarillo", hex: "#ffff00" },
  { name: "Verde", hex: "#39b54a" },
]


export function ColorSelector({onChange}){
  const [selectedColor, setSelectedColor] = useState("");

  const inputRef = useRef()



  return (
    <View style={tw``}>
      <View style={tw`row mb-2`}>
        <Text style={tw`text-gray-500 mr-4`}>Color</Text>

        <Text style={tw`text-gray-400`}>{selectedColor}</Text>

        {
          selectedColor === null &&
            <TextInput
              ref={inputRef}
              style={tw`border border-gray-400 rounded-lg w-30 px-3`}
              onChangeText={value => {
                onChange?.(value)
              }}
            />
        }
      </View>

      <View style={tw`row gap-x-4 gap-y-2`}>
        {
          vehicleColors.map(color =>
            <ColorButton
              key={color.name}
              onPress={() => {
                setSelectedColor(color.name)
                onChange?.(color.name)
              }}
              color={color.hex}
              style={color.style}
              selected={selectedColor == color.name}
            />
          )
        }

        <TouchableOpacity
          onPress={() => {
            setSelectedColor(null)
            
            setTimeout(() => inputRef.current?.focus(), 300)
          }}
        >
          <Text style={tw`text-secondary text-base`}>otro</Text>
        </TouchableOpacity>
      </View>
    </View>
  )
}


export default function NewVehicleModal({ onRequestClose, visible, communityId, unitId, onVehicleCreated }) {
  const { control, handleSubmit, reset, setValue } = useForm();

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onVehicleCreated,
    onError: (error) => { },
    successToastMessage: "Vehículo creado",
    endpoint: `/communities/${communityId}/units/${unitId}/vehicles`,
  })

  useEffect(() => {
    reset({})
  }, [visible]);

  return (
    <BottomSheet onRequestClose={onRequestClose} visible={visible} height={440}>
      <View style={tw`pt-5 px-5`}>
        <Text style={tw`mb-4 text-lg font-600 text-secondary`}>Registrar vehículo</Text>
        
        {/* Marca/Modelo */}
        <View style={tw`mb-3`}>
          <Text style={tw`text-gray-500 mb-2`}>Marca / Modelo</Text>

          <Input control={control} name='brand' rules={{required: true}} />
        </View>

        
        {/* Color */}
        <View style={tw`mb-8`}>
          <ColorSelector onChange={(value) => setValue("color", value)} />
        </View>
        

        {/* Placas */}
        <View style={tw`mb-0`}>
          <Text style={tw`text-gray-500 mb-2`}>Placas</Text>

          <Input control={control} name='plate_number' />
        </View>

        <IconButton
          disabled={isSubmitting}
          title={isSubmitting ? "Guardando" : "Guardar vehículo"}
          style={tw`self-end`}
          onPress={handleSubmit(submitForm)}
        />
      </View>
    </BottomSheet>
  );
}
